export const GET_FILE_URL = 'common@get-file-url';
export const GET_USER_DATA = 'common@get-user-data';